import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Dices, Flame, Sparkles, Gift, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const Slotlar: React.FC = () => {
  const categories = [
    {
      title: 'Lobby',
      description: 'Tüm slot oyunlarına göz atın',
      icon: Dices,
      path: '/slotlar/lobby',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Popüler Oyunlar',
      description: 'En çok oynanan slot oyunları',
      icon: Flame,
      path: '/slotlar/populer',
      color: 'from-red-500 to-orange-500'
    },
    {
      title: 'Yeni Çıkanlar',
      description: 'En yeni slot oyunlarını keşfedin',
      icon: Sparkles,
      path: '/slotlar/yeni',
      color: 'from-purple-500 to-pink-500'
    },
    {
      title: 'Free Spinler',
      description: 'Ücretsiz dönüş fırsatları',
      icon: Gift,
      path: '/slotlar/free-spin',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <>
      <SEO
        title="Slotlar | Slot Oyunları"
        description="En popüler slot oyunlarını keşfedin, yeni çıkanları deneyin ve free spin fırsatlarından yararlanın."
        url="/slotlar"
      />
      <div className="min-h-screen bg-dark-900 pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Slotlar
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Yüzlerce slot oyunu arasından seçiminizi yapın
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <Link
                    to={category.path}
                    className="group block bg-dark-800/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-700 hover:border-primary-500/50 transition-all duration-300 h-full"
                  >
                    <div className={`w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-r ${category.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <h2 className="text-xl font-bold text-white text-center mb-2 group-hover:text-primary-400 transition-colors">
                      {category.title}
                    </h2>
                    <p className="text-gray-400 text-center text-sm mb-4">
                      {category.description}
                    </p>
                    <div className="flex items-center justify-center text-primary-400 group-hover:text-primary-300">
                      <span className="mr-2 text-sm">Keşfet</span>
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Slotlar;
